import { useState, useEffect } from "react";
import { FaVideo, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { SlOptions } from "react-icons/sl";
import UnfollowPopup from "../components/UnfollowPopup";
import PrivateCallModal from "../components/PrivateCallModal";
import { GetFollowingList } from "../services/api";
import { getMediaUrl } from "../utils/helpers";

export default function Followings() {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(false);
  const [followingList, setFollowingList] = useState([]);

  const [privateCall, setPrivateCall] = useState(false);
  const [hostCallData, setHostCallData] = useState([]);

  useEffect(() => {
    fetchFollowingList();
  }, []);

  const fetchFollowingList = () => {
    GetFollowingList()
      .then((res) => {
        setFollowingList(res.data);
      })
      .catch((err) => {
        console.log(err)
      });
  }

  return (
    <div className="min-h-screen bg-black text-white px-4 md:px-24 pt-[85px] pb-20 relative">

      {followingList.length === 0 && (
        <div className="w-full flex justify-center mt-40">
          <p className="text-gray-400 text-lg">Start following people you like</p>
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {followingList?.map((item, _id) => (
          <div key={_id} className="relative">

            {/* OPTIONS BUTTON — OUTSIDE CARD CLICK */}
            <button
              className="absolute top-2 right-2 z-20 bg-black/50 p-2 rounded-full"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedUser(_id);
                setShowPopup(true);
              }}
            >
              <SlOptions size={16} />
            </button>

            {/* VIDEO ICON */}
            <button className="absolute bottom-3 right-2 z-20 bg-red-500 p-2 rounded-full"
              onClick={(e) => {
                e.stopPropagation();
                setHostCallData(item?.user);
                setPrivateCall(true);
              }}
            >
              <FaVideo size={16} />
            </button>

            {/* CARD CLICKABLE AREA */}
            <div
              onClick={() => navigate(`/user/${item.user._id}`)}
              className="rounded-2xl overflow-hidden bg-gray-900 cursor-pointer hover:scale-[1.02] transition"
            >

              {item?.stories?.length > 0 ? (
                <video
                  src={getMediaUrl(item?.stories[0]?.url)}
                  className="h-[250px] md:h-[300px] lg:h-[360px] w-full object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              ) : item?.posts?.length > 0 ? (
                <img
                  src={getMediaUrl(item?.posts[0]?.url)}
                  alt={item?.user?.name}
                  className="h-[250px] md:h-[300px] lg:h-[360px] w-full object-cover"
                />
              ) : (
                <img
                  src={getMediaUrl(item?.user?.ppImageURL)}
                  alt={item?.user?.name}
                  className="h-[250px] md:h-[300px] lg:h-[360px] w-full object-cover"
                />
              )}

              {/* USER INFO */}
              <div className="absolute bottom-3 left-2 bg-black/60 px-3 py-1 rounded-full flex items-center gap-1 text-sm">
                <span>
                  {item?.user?.name.length > 5 ? item?.user?.name.slice(0, 5) + "..." : item?.user?.name}, {item?.user?.age}
                </span>
                {item?.user?.is_verified && (
                  <FaCheckCircle size={14} className="text-blue-400" />
                )}
              </div>

            </div>
          </div>
        ))}
      </div>

      <UnfollowPopup
        userId={selectedUser}
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
      />

      {privateCall &&
        <PrivateCallModal
          onClose={() => setPrivateCall(false)}
          host={hostCallData}
        />
      }

    </div>
  );
}